import { Map } from "immutable";
import _ from "lodash";

import sortFunctions from "../items/sortFunctions";
import selectors from "./selectors";

const findPreviousId = (list, index, skipValues) => {
  let i = index - 1;
  while (i >= 0) {
    if (skipValues.indexOf(list[i]) == -1) {
      return list[i];
    }
    i--;
  }
  return null;
};

const findNextId = (list, index, skipValues) => {
  const len = list.length;
  let i = index + 1;
  while (i < len) {
    if (skipValues.indexOf(list[i]) == -1) {
      return list[i];
    }
    i++;
  }
  return null;
};

const moveToPosition = (list, oldIndex, newIndex) => {
  const item = list[oldIndex];
  const result = _.clone(list);
  result.splice(oldIndex, 1);
  result.splice(newIndex, 0, item);
  return result;
};

const sortSequenceIndexes = (sequenceIds, itemsById, relatedItemIds) => {
  const filteredItemsById = Map(
    sequenceIds.reduce((result, id) => {
      result[id] = itemsById.get(id);
      return result;
    }, {})
  );

  const startSequence = [...sequenceIds];

  // Sort the events by date.
  const sequenceIndexById = selectors.getSequenceIndexById(sequenceIds);

  const newDateOrder = filteredItemsById
    .filter(o => o.startDate && !_.isNil(o.startDate.timestamp))
    .map(obj => {
      return { id: obj.id, startDate: obj.startDate, sequenceIndex: sequenceIndexById.get(obj.id) };
    })
    .toList()
    .sort(sortFunctions.byDateThenSequence)
    .map(o => o.id)
    .toArray();

  // What has changed?
  let changedIds = _.filter(relatedItemIds, id => sequenceIds.includes(id));
  let finalSequence = startSequence;

  // Which IDs need to be ignored each loop... once something is settled, it doesn't have to be ignored again
  let remainingIds = _.clone(changedIds);
  // Iterate through each changedId, and work out where it needs to be in the new list.
  _.each(changedIds, id => {
    // Where does it sit in date order?
    const dateIndex = newDateOrder.indexOf(id);

    // If it doesn't have a date, then we don't need to worry about trying to move it
    if (dateIndex < 0) {
      remainingIds = remainingIds.slice(1);
      return;
    }

    // Find the items it must sit within...
    const prevId = findPreviousId(newDateOrder, dateIndex, remainingIds);
    const nextId = findNextId(newDateOrder, dateIndex, remainingIds);

    // Now find the relevant sequence indexes
    const initialIndex = finalSequence.indexOf(id);
    const lowerIndex = prevId ? finalSequence.indexOf(prevId) : 0;
    const upperIndex = nextId ? finalSequence.indexOf(nextId) : finalSequence.length;
    if (initialIndex < lowerIndex) {
      // Move to lowerIndex
      finalSequence = moveToPosition(finalSequence, initialIndex, lowerIndex);
    } else if (initialIndex > upperIndex) {
      // Move to upperIndex
      finalSequence = moveToPosition(finalSequence, initialIndex, upperIndex);
    }
    remainingIds = remainingIds.slice(1);
  });

  return finalSequence;
};

const sequenceIndexesAfterDateChange = (newGlobalState, ids, _prevGlobalState) => {
  const sequenceIds = newGlobalState.data.sequence;
  const itemsById = newGlobalState.data.items.byId;

  return sortSequenceIndexes(sequenceIds.toArray(), itemsById, ids);
};

export { sequenceIndexesAfterDateChange, sortSequenceIndexes };
